/**
 * @file text.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene funciones para manipular texto
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-05-27
 * @author Correcta
 * @author Daniel Sentamans
 * @copyright © Correcta
 * @license Private
 * */

export const capitalize = (text: string) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const uncapitalize = (text: string) => {
  if (!text) return "";
  return text.charAt(0).toLowerCase() + text.slice(1);
};
